import Box from '@totallymoney/ui/components/Box'
import Text from '@totallymoney/ui/components/Text'

const SecuredLoanDisclaimer = () => {
    return (
        <Box>
            <Text>
                <strong>SECURED LOANS:</strong> THINK CAREFULLY BEFORE SECURING
                OTHER DEBTS AGAINST YOUR HOME. YOUR HOME MAY BE REPOSSESSED IF
                YOU DO NOT KEEP UP REPAYMENTS ON A MORTGAGE OR ANY OTHER DEBT
                SECURED ON IT.{' '}
            </Text>
        </Box>
    )
}

export default SecuredLoanDisclaimer
